import { useBadgeStyles } from './Badge.styles';

export default function Badge({ label }) {
  const { styles } = useBadgeStyles();
  return <div className={styles.badge}>{label}</div>;
}
